import useLocalStorageState from "use-local-storage-state"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { GetRequest } from "../Utils/hooks/ApiHandler#"
import { toast } from "sonner"
import Card from "react-bootstrap/Card"
import { Row, Col, Image, Badge, Button } from "react-bootstrap"
import {
    IconMail,
    IconPhone,
    IconUser,
    IconId,
    IconUserCircle,
    IconPencil,
} from "@tabler/icons-react"
import { baseURL, imageURL } from "../Utils/constants/constant"
import { BsArrowLeft } from "react-icons/bs"

export const SetupUserDetails = () => {
    const themeColor = "#7a3a5e"
    // A slightly lighter shade for gradients to create depth
    const themeGradient = `linear-gradient(135deg, ${themeColor} 0%, #9d4d79 100%)`

    // --- State & Hooks ---
    const [customer, setCustomer] = useLocalStorageState("customer")
    const [setup, setSetup] = useState({})
    const navigate = useNavigate()

    const headers = {
        Authorization: customer?.token?.authorization,
        Authentication: customer?.token?.authentication,
    }
    const rf = customer?.token?.authentication
    const customer_id = customer?.customer_details?.customer_id

    // --- Effects ---

    // 1. Auth Check
    useEffect(() => {
        if (customer?.customer_details?.user_type !== "1") {
            navigate("/dashboard")
        }
    }, [customer, navigate])

    // 2. Fetch Data
    useEffect(() => {
        ; (async () => {
            const res = await GetRequest(
                `profile/fetchPOCDetails/${customer_id}`,
                { headers },
                { customer, setCustomer, rf: headers.Authentication, navigate }
            )

            if (res.err) {
                toast.error("Error Fetching User Data")
                return
            }
            setSetup(res.data || {})
        })()
    }, [customer, customer_id])

    // Helper to format full name
    const getFullName = () => {
        const { salutation, first_name, middle_name, last_name } = setup
        return [salutation, first_name, middle_name, last_name]
            .filter(Boolean)
            .join(" ")
    }

    // Helper to format phone
    const getFormattedPhone = () => {
        if (!setup?.phone) return "N/A"
        // If phone doesn't start with country code (simple check), append it for display
        if (
            setup?.country_code &&
            !setup?.phone.toString().startsWith(setup?.country_code)
        ) {
            return `+${setup.country_code} ${setup.phone}`
        }
        return `+${setup.phone}` // Assuming phone saved with code or just displaying raw
    }

    return (
        <>
            <div className="container">
                {/* Page Header */}
                {/* <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h2 className="h3 fw-bold text-dark">User Profile</h2>
            <p className="text-muted mb-0 small">
              View your personal and contact details.
            </p>
          </div>
        </div> */}
                <div className="mb-3 d-flex justify-content-between align-items-end">
                    <div style={{ lineHeight: "0.8rem" }}>
                        <h6
                            className="addEnquiryHead"
                            style={{ fontWeight: "400", color: "black", fontSize: "1.13rem" }}
                        >
                            User Profile
                        </h6>
                        <p className="text-muted mb-0 small">
                            View your personal and contact details.
                        </p>
                    </div>
                    <Button className="btn btn-default" onClick={() => navigate(-1)}>
                        <BsArrowLeft className="me-1" /> Back
                    </Button>
                </div>
                <hr
                    className="mt-3 mb-4"
                    style={{
                        borderTop: "0.5px solid #6c757d",
                        opacity: "0.3",
                    }}
                />
                <Row className="g-4">
                    {/* --- Left Column: Identity Card --- */}
                    <Col lg={4}>
                        <Card
                            // className="border-0 shadow-sm overflow-hidden h-100"
                            className="customBorderforCard"
                            style={{ borderRadius: "6px", height: "97%" }}
                        >
                            {/* Decorative Background */}
                            <div
                                style={{
                                    height: "100px",
                                    background: themeGradient,
                                }}
                            ></div>
                            {console.log("img", `${imageURL}${setup?.profile_img}`)}
                            <Card.Body className="text-center position-relative pt-0">
                                {/* Profile Image - Negative Margin to pull it up */}
                                <div
                                    className="d-inline-block p-1 bg-white rounded-circle shadow-sm position-relative"
                                    style={{ marginTop: "-50px" }}
                                >
                                    <Image
                                        src={
                                            setup?.profile_img
                                                ? `${imageURL}${setup?.profile_img}`
                                                : "https://placehold.co/150?text=User"
                                        }
                                        alt="Profile"
                                        width={100}
                                        height={100}
                                        className="rounded-circle object-fit-cover"
                                        onError={(e) => {
                                            e.target.src = "https://placehold.co/150?text=Error"
                                        }}
                                    />
                                </div>

                                <h5 className="fw-bold mt-4 mb-1">
                                    {getFullName() || "User Name"}
                                </h5>
                                <p className="text-muted small mb-3">Primary Account Holder</p>

                                <div className="d-flex justify-content-center gap-2">
                                    <span className="badge bg-success-transparent px-3 py-2">
                                        {" "}
                                        Active User
                                    </span>

                                    {/* <Badge
                    bg="light"
                    className="border fw-normal px-3 py-2"
                    style={{ color: themeColor }}
                  >
                    Active User
                  </Badge> */}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* --- Right Column: Details Grid --- */}
                    <Col lg={8}>
                        <Card
                            className="customBorderforCard"
                            style={{ borderRadius: "6px" }}
                        >
                            <Card.Body className="p-3">
                                {/* <div className="mb-4 pb-2 border-bottom">
                  <h6 className="fw-bold text-muted small mb-0 d-flex align-items-center">
                    <IconUserCircle
                      size={18}
                      className="me-2"
                      style={{ color: themeColor }}
                    />{" "}
                    Personal Information
                  </h6>
                </div> */}
                                <div className="d-flex align-items-center mb-4">
                                    <div
                                        className="bg-light p-2 rounded-circle me-3"
                                        style={{ border: "1px solid rgb(35 183 229 / 20%)" }}
                                    >
                                        <IconUser
                                            size={24}
                                            style={{
                                                color: "rgb(35 183 229 / 97%)",
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <h4
                                            className="mb-0"
                                            style={{
                                                fontSize: "18px",
                                                fontWeight: "500",
                                            }}
                                        >
                                            Personal Information
                                        </h4>
                                        <small className="text-muted">
                                            Basic identity and classification
                                        </small>
                                    </div>
                                </div>

                                <Row className="g-3 mb-3 mx-1">
                                    <Col md={6}>
                                        <div className="d-flex align-items-start">
                                            <div className="me-3 mt-1 text-muted">
                                                <IconUser size={20} />
                                            </div>
                                            <div>
                                                <small
                                                    className="text-muted d-block"
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        letterSpacing: "0.5px",
                                                    }}
                                                >
                                                    First Name
                                                </small>
                                                <span className="fw-medium text-dark" style={{ textTransform: "capitalize" }}>
                                                    {setup?.first_name || "-"}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="d-flex align-items-start">
                                            <div className="me-3 mt-1 text-muted">
                                                <IconUser size={20} />
                                            </div>
                                            <div>
                                                <small
                                                    className="text-muted d-block"
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        letterSpacing: "0.5px",
                                                    }}
                                                >
                                                    Last Name
                                                </small>
                                                <span className="fw-medium text-dark" style={{ textTransform: "capitalize" }}>
                                                    {setup?.last_name || "-"}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="d-flex align-items-start">
                                            <div className="me-3 mt-1 text-muted">
                                                <IconId size={20} />
                                            </div>
                                            <div>
                                                <small
                                                    className="text-muted d-block"
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        letterSpacing: "0.5px",
                                                    }}
                                                >
                                                    Salutation
                                                </small>
                                                <span className="fw-medium text-dark">
                                                    {setup?.salutation || "-"}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="d-flex align-items-start">
                                            <div className="me-3 mt-1 text-muted">
                                                <IconUser size={20} />
                                            </div>
                                            <div>
                                                <small
                                                    className="text-muted d-block"
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        letterSpacing: "0.5px",
                                                    }}
                                                >
                                                    Middle Name
                                                </small>
                                                <span className="fw-medium text-dark">
                                                    {setup?.middle_name || "-"}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {/* <div className="mb-4 pb-2 border-bottom">
                  <h6 className="fw-bold text-muted small mb-0 d-flex align-items-center">
                    <IconMail
                      size={18}
                      className="me-2"
                      style={{ color: themeColor }}
                    />{" "}
                    Contact Details
                  </h6>
                </div> */}
                                <hr />
                                <div className="d-flex align-items-center mb-4 pt-1">
                                    <div
                                        className="bg-light p-2 rounded-circle me-3"
                                        style={{ border: "1px solid rgb(35 183 229 / 20%)" }}
                                    >
                                        <IconMail
                                            size={24}
                                            style={{
                                                color: "rgb(35 183 229 / 97%)",
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <h4
                                            className="mb-0"
                                            style={{
                                                fontSize: "18px",
                                                fontWeight: "500",
                                            }}
                                        >
                                            Contact Details
                                        </h4>
                                        <small className="text-muted">
                                            Basic identity and classification
                                        </small>
                                    </div>
                                </div>

                                <Row className="g-3 mx-1 row">
                                    <Col md={6}>
                                        <div className="d-flex align-items-start">
                                            <div className="me-3 mt-1 text-muted">
                                                <IconMail size={20} />
                                            </div>
                                            <div>
                                                <small
                                                    className="text-muted d-block"
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        letterSpacing: "0.5px",
                                                    }}
                                                >
                                                    Email
                                                </small>
                                                <span className="fw-medium text-dark">
                                                    {setup?.email || "-"}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="d-flex align-items-start">
                                            <div className="me-3 mt-1 text-muted">
                                                <IconPhone size={20} />
                                            </div>
                                            <div>
                                                <small
                                                    className="text-muted d-block"
                                                    style={{
                                                        fontSize: "0.75rem",
                                                        letterSpacing: "0.5px",
                                                    }}
                                                >
                                                    Phone
                                                </small>
                                                <span className="fw-medium text-dark">
                                                    {getFormattedPhone()}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>

            <style jsx>{`
        .object-fit-cover {
          object-fit: cover;
        }
        .customBorderforCard {
          border: 1px solid #d4e9f0 !important;
        }
      `}</style>
        </>
    )
}